$(document).ready(function(){

    $('.testimonial-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: false,    
      autoplay: true,        // enable auto play
      autoplaySpeed: 2000,
      adaptiveHeight: true,
        responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            arrows: false,
          }
        },
      ]
    });

  });



  // javasript

  document.addEventListener("DOMContentLoaded", function () {



  const faqItems = document.querySelectorAll(".faqSec .faq-item");

  faqItems.forEach((item) => {
    const question = item.querySelector(".faqSec .faq-question");

    question.addEventListener("click", () => {
      // Close other items
      faqItems.forEach((i) => {
        if (i !== item) {
          i.classList.remove("active");
        }
      });
      // Toggle current item
      item.classList.toggle("active");
    });
  });



// product slider 

   
        const slider = document.querySelector(".product__media-list");
 
        let isDown = false;
        let startX;
        let scrollLeft;
 
        if (slider) {
          slider.addEventListener("mousedown", (e) => {
            isDown = true;
            slider.classList.add("active");
            startX = e.pageX - slider.offsetLeft;
            scrollLeft = slider.scrollLeft;
          });
 
          slider.addEventListener("mouseleave", () => {
            isDown = false;
            slider.classList.remove("active");
          });
 
          slider.addEventListener("mouseup", () => {
            isDown = false;
            slider.classList.remove("active");
          });
 
          slider.addEventListener("mousemove", (e) => {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - slider.offsetLeft;
            const walk = (x - startX) * 2; // scroll speed
            slider.scrollLeft = scrollLeft - walk;
          });
        }
      



        // shopify header search

          // const input = document.querySelector("#CustomSearchInput");
          // const resultsBox = document.querySelector("#CustomPredictiveResults");

          // if (!input || !resultsBox) return;

          // let controller;

          // input.addEventListener("input", async function () {
          //   const query = this.value.trim();

          //   if (!query.length) {
          //     resultsBox.innerHTML = "";
          //     resultsBox.classList.remove("active");
          //     return;
          //   }

          //   // Cancel any previous request
          //   if (controller) controller.abort();
          //   controller = new AbortController();

          //   try {
          //     const res = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,page&resources[limit]=5`, {
          //       signal: controller.signal
          //     });
          //     const data = await res.json();

          //     let html = "";

          //     // Products
          //     if (data.resources.results.products.length) {
          //       html += `<h4 class="custom-predictive-title">Products</h4><ul class="custom-predictive-list">`;
          //       data.resources.results.products.forEach(product => {
          //         html += `
          //           <li class="custom-predictive-item">
          //             <a href="${product.url}" class="custom-predictive-link">
          //               ${product.image ? `<img src="${product.image}" alt="${product.title}" class="custom-predictive-img"/>` : ""}
          //               <span class="custom-predictive-text">${product.title}</span>
          //             </a>
          //           </li>`;
          //       });
          //       html += `</ul>`;
          //     }

          //     // Pages
          //     if (data.resources.results.pages.length) {
          //       html += `<h4 class="custom-predictive-title">Pages</h4><ul class="custom-predictive-list">`;
          //       data.resources.results.pages.forEach(page => {
          //         html += `
          //           <li class="custom-predictive-item">
          //             <a href="${page.url}" class="custom-predictive-link">
          //               <span class="custom-predictive-text">${page.title}</span>
          //             </a>
          //           </li>`;
          //       });
          //       html += `</ul>`;
          //     }

          //     resultsBox.innerHTML = html || `<p class="custom-predictive-empty">No results found</p>`;
          //     resultsBox.classList.add("active");

          //   } catch (e) {
          //     if (e.name !== "AbortError") {
          //       console.error("Custom predictive search error:", e);
          //     }
          //   }
          // });


}); // end document


